<ejs-toast #toasttype id='toasttype' (beforeOpen)="onBeforeOpenToast($event)" (close)="onCloseToast()"
  [position]="toastPosition">
</ejs-toast>
<div class="prelogin-outer-bg">
  <div class="e-h-100vh d-flex align-items-center row">
    <app-spinner></app-spinner>
    <div class="col e-pre-login-form-box e-py-4" id="e-pre-login-form-box">
      <div class="bg-white align-items-center e-panel-user-form e-pre-login-form-inner-box">
        <div class="e-panel-user-form-box e-py-5 e-px-7">
          <div class="e-mb-4 e-text-center">
            <img src="/assets/images/syntrio-logo-blue.png" alt="Mitratech Logo" height="44px">
          </div>
          <h4 class="e-mb-4 font-weight-bold e-text-center user-form-heading">Respond Login</h4>

          <form [formGroup]="loginForm" class="" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-12 e-form-group e-mb-4">
                <ejs-textbox placeholder="Case Number" cssClass="e-autofill e-outline" autofill="on"
                floatLabelType="Always" formControlName="caseNumber"></ejs-textbox>
                @if (submitted && formControl.caseNumber.errors && formControl.caseNumber.errors.required) {
                  <div
                    class="validation-error-box">
                    Case Number is required
                  </div>
                }
              </div>
              <div class="col-12 e-form-group" [ngClass]="showCaptcha ? 'e-mb-3' : 'e-mb-4' ">
                <ejs-textbox placeholder="PIN" type="password" cssClass="e-autofill e-outline"
                autofill="on" floatLabelType="Always" formControlName="pin"></ejs-textbox>
                @if (submitted && formControl.pin.errors && formControl.pin.errors.required) {
                  <div
                    class="validation-error-box">
                    PIN is required
                  </div>
                }
              </div>
            </div>
            <div class="row">
              @if (showCaptcha) {
                <div class="col-12 e-form-group e-mb-4">
                  <ngx-recaptcha2 #captchaElem class="g-recaptcha" [siteKey]="siteKey"
                    (error)="handleCaptchaError()" (expire)="handleCaptchaExpire()"
                    formControlName="captcha">
                  </ngx-recaptcha2>
                  @if (showCaptchRequiredMessage) {
                    <div class="validation-error-box">
                      Captcha is required
                    </div>
                  }
                </div>
              }
              <div class="col-12">
                <button ejs-button type="submit"
                  cssClass="e-primary e-block e-bigger e-btn font-weight-bold e-css e-control e-lib">Log
                  In
                </button>
              </div>
              <div class="col-12 e-text-center e-mt-4">
                <a class="e-pointer e-text-underline font-weight-bold" (click)="GoToCreatePin()">Don't
                have a PIN?</a>
              </div>
            </div>
          </form>
        </div>
      </div>
      <app-footer [includeLinks]="true"></app-footer>
    </div>
  </div>
</div>